import "core-js/modules/es.array.concat.js";
/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import { _PaginationSpan } from "./styles";
export function RowRangeDisplay(props) {
  var pageSize = props.pageSize,
    rowCount = props.rowCount,
    currentPage = props.currentPage;
  var paginationText = useMemo(function () {
    if (rowCount === 0) return '0 of 0';
    var rowStart = (currentPage - 1) * pageSize + 1;
    var rowEnd = Math.min(currentPage * pageSize, rowCount);
    return "".concat(rowStart, " - ").concat(rowEnd, " of ").concat(rowCount);
  }, [pageSize, rowCount, currentPage]);
  return /*#__PURE__*/React.createElement(_PaginationSpan, null, paginationText);
}
export default RowRangeDisplay;